// Imports for external libraries go here.
import React, { FC } from 'react';
import Link from 'next/link';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { LegalMultiLinkComponentProps } from './LegalMultiLink.types';
import { StyledLegalMultiLink } from './LegalMultiLink.styles';
export const LegalMultiLinkConfig = {
  emptyLabel: 'LegalMultiLink',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/multilinks`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LegalMultiLink = (props: any) => {
  return (
    <EditableComponent config={LegalMultiLinkConfig} {...props}>
      <LegalMultiLinkComponent multiLinksList={props.model.multiLinksList} />
    </EditableComponent>
  );
};

export const LegalMultiLinkComponent: FC<LegalMultiLinkComponentProps> = ({ multiLinksList }) => {
  return (
    <StyledLegalMultiLink data-testid="legal-LegalMultiLink" data-component-name="o-legal-LegalMultiLink">
      <nav className="multiLink-nav">
        {multiLinksList.map((link, index) => {
          const target = link.openInNewTab ? '_blank' : '_self';
          const rel = link.openInNewTab ? 'noopener noreferrer' : undefined;
          const linkClasses = `multiLink-link ${link.isCurrentLink ? 'active' : ''}`;

          return (
            <Link key={index} href={link.href} target={target} rel={rel} className={linkClasses}>
              {link.label}
            </Link>
          );
        })}
      </nav>
    </StyledLegalMultiLink>
  );
};
